// Small embedded WAV data URIs, so alert sounds don't depend on a static
// asset existing on the server (and work identically offline/in the SW).

export const RINGTONE_DATA_URI =
  'data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBjiR1/LMeSwFJHfH8N2QQAo=';

// DotLink's own call sounds (files in /public/sounds, generated for the app):
//  - RING_URL    bright bell arpeggio — what the OWNER hears for an incoming call
//  - CALLING_URL soft swelling two-note pad — what the CALLER hears while waiting
// Deliberately different so you always know which side of a call you're on.
// Bump SOUND_VERSION whenever a file changes — browsers cache by URL, so an
// unchanged URL keeps playing the OLD sound.
const SOUND_VERSION = '3';
export const RING_URL = `/sounds/dotlink-ring.wav?v=${SOUND_VERSION}`;
export const CALLING_URL = `/sounds/dotlink-calling.wav?v=${SOUND_VERSION}`;
// Inaudible loop used by "Ring mode" to keep the page alive in the background.
export const STANDBY_URL = `/sounds/dotlink-standby.wav?v=${SOUND_VERSION}`;

// Short two-tone chime for new messages — distinct from the ringtone above.
export const MESSAGE_TONE_DATA_URI =
  'data:audio/wav;base64,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';

// iOS Safari and Android Chrome both refuse to play audio triggered from
// code alone (e.g. a poll interval firing) unless that exact <audio>
// element has already been played once inside a genuine user gesture — a
// gesture anywhere on the page counts, it doesn't have to be a "sound"
// button. Desktop Chrome is far more lenient, which is why this only shows
// up on phones. Fix: keep ONE cached Audio object per sound (never
// `new Audio()` per play — a fresh element is unactivated again on iOS),
// and silently play+pause each one on the very first tap/touch to unlock
// them for every subsequent programmatic .play().
const cache = new Map();
const getAudio = (dataUri) => {
  let audio = cache.get(dataUri);
  if (!audio) {
    audio = new Audio(dataUri);
    audio.preload = 'auto';
    cache.set(dataUri, audio);
  }
  return audio;
};

let unlocked = false;
const isWanted = (url) =>
  (url === RING_URL && wantRing) || (url === CALLING_URL && wantCalling) || (url === STANDBY_URL && wantStandby);
const unlock = () => {
  if (unlocked) return;
  unlocked = true;
  for (const [url, audio] of cache.entries()) {
    // Never touch a sound that is actually in use right now (ringing, calling,
    // ring-mode standby): the play()+pause() below would cut it off.
    if (isWanted(url)) continue;
    // Muted while unlocking, so the first few milliseconds of the ringtone / message
    // tone are never audible (that was the "blip" heard right after a refresh).
    audio.muted = true;
    audio.play().then(() => {
      audio.pause();
      audio.currentTime = 0;
      audio.muted = false;
    }).catch(() => {
      // Still locked (e.g. gesture didn't count) — next real tap retries.
      audio.muted = false;
      unlocked = false;
    });
  }
  document.removeEventListener('pointerdown', unlock);
  document.removeEventListener('touchstart', unlock);
};

if (typeof document !== 'undefined') {
  // Pre-warm the cache so the very first gesture has something to unlock,
  // even if no sound has been asked to play yet.
  getAudio(RINGTONE_DATA_URI);
  getAudio(RING_URL);
  getAudio(CALLING_URL);
  getAudio(STANDBY_URL);
  getAudio(MESSAGE_TONE_DATA_URI);
  document.addEventListener('pointerdown', unlock, { passive: true });
  document.addEventListener('touchstart', unlock, { passive: true });
}

// Fire-and-forget play, safe wherever autoplay may be blocked (e.g. before
// any user gesture) — a rejected promise there is expected, not a bug.
export const playSound = (dataUri) => {
  try {
    const audio = getAudio(dataUri);
    audio.currentTime = 0;
    audio.play().catch(() => {});
  } catch {}
};

// ---- Looping call sounds -------------------------------------------------
let ringVibrateTimer = null;
let wantRing = false;
let wantCalling = false;
let wantStandby = false;

// After a page refresh browsers block audio until the user taps/clicks once.
// Instead of failing silently we remember that the sound is wanted, tell the UI
// (so it can say "tap to hear the ring") and start it on the very next touch.
const blockedListeners = new Set();
let blocked = false;
const setBlocked = (v) => {
  if (blocked === v) return;
  blocked = v;
  blockedListeners.forEach((fn) => fn(v));
};
export const onAudioBlocked = (fn) => {
  blockedListeners.add(fn);
  return () => blockedListeners.delete(fn);
};
export const isAudioBlocked = () => blocked;

const armResume = () => {
  const resume = () => {
    document.removeEventListener('pointerdown', resume, true);
    document.removeEventListener('keydown', resume, true);
    if (wantRing) attempt(RING_URL, 1, () => wantRing);
    if (wantCalling) attempt(CALLING_URL, 0.8, () => wantCalling);
    if (wantStandby) attempt(STANDBY_URL, 0.05, () => wantStandby);
  };
  document.addEventListener('pointerdown', resume, { capture: true, once: true });
  document.addEventListener('keydown', resume, { capture: true, once: true });
};

const attempt = (url, volume, stillWanted) => {
  try {
    const audio = getAudio(url);
    audio.loop = true;
    audio.volume = volume;
    audio.currentTime = 0;
    const p = audio.play();
    if (p && p.then) {
      p.then(() => setBlocked(false)).catch(() => {
        if (stillWanted()) { setBlocked(true); armResume(); }
      });
    }
  } catch {}
};
const loopStop = (url) => {
  try {
    const audio = getAudio(url);
    audio.pause();
    audio.loop = false;
    audio.currentTime = 0;
  } catch {}
};

// Owner side: incoming call — loud bell ringtone + repeating vibration.
export const startRingtone = (volume = 1) => {
  wantRing = true;
  attempt(RING_URL, volume, () => wantRing);
  if (navigator.vibrate && !ringVibrateTimer) {
    const buzz = () => navigator.vibrate([400, 200, 400]);
    buzz();
    ringVibrateTimer = setInterval(buzz, 2000);
  }
};

export const stopRingtone = () => {
  wantRing = false;
  loopStop(RING_URL);
  if (ringVibrateTimer) {
    clearInterval(ringVibrateTimer);
    ringVibrateTimer = null;
    if (navigator.vibrate) navigator.vibrate(0);        // only cancel a buzz we actually started
  }
  if (!wantCalling) setBlocked(false);
};

// Caller side: "calling…" tone while the owner's phone is ringing.
export const startCalling = (volume = 0.8) => {
  wantCalling = true;
  attempt(CALLING_URL, volume, () => wantCalling);
};
export const stopCalling = () => {
  wantCalling = false;
  loopStop(CALLING_URL);
  if (!wantRing) setBlocked(false);
};

// Call from inside a tap handler: unlocks audio for later programmatic play
// and lets the user hear what an incoming call will sound like.
// Unlock audio without playing anything audible (used for silent auto-setup).
export const primeAudio = () => {
  unlocked = false;
  unlock();
};

export const primeAndTestRing = () => {
  startRingtone(1);          // mark the ring as in use first so unlock() leaves it alone
  unlocked = false;
  unlock();
  setTimeout(stopRingtone, 3300);
};

// ---- Ring mode (keeps DotLink alive so calls can ring out loud) -----------
// While this plays, the browser treats the page as an active media page: it is
// not frozen or throttled in the background or on a locked screen, so incoming
// calls are noticed instantly and the real ringtone can play. The loop itself
// is inaudible. Trade-off: slightly more battery, and it can pause other audio.
export const RING_MODE_KEY = 'dl_ring_mode';
// ON by default: only an explicit "0" (the user switched it off) disables it.
export const isRingModeEnabled = () => {
  try { return localStorage.getItem(RING_MODE_KEY) !== '0'; } catch { return true; }
};
export const setRingModeEnabled = (on) => {
  try { localStorage.setItem(RING_MODE_KEY, on ? '1' : '0'); } catch { /* ignore */ }
};

export const startStandby = () => {
  wantStandby = true;
  attempt(STANDBY_URL, 0.05, () => wantStandby);
  try {
    if ('mediaSession' in navigator) {
      navigator.mediaSession.metadata = new window.MediaMetadata({
        title: 'DotLink is ready for calls',
        artist: 'Ring mode is on',
        artwork: [{ src: '/logo192.png', sizes: '192x192', type: 'image/png' }],
      });
      navigator.mediaSession.playbackState = 'playing';
    }
  } catch { /* media session not available */ }
};

export const stopStandby = () => {
  wantStandby = false;
  loopStop(STANDBY_URL);
  try {
    if ('mediaSession' in navigator) {
      navigator.mediaSession.playbackState = 'none';
      navigator.mediaSession.metadata = null;
    }
  } catch { /* ignore */ }
};
